export const hasAnyBookableSlot = (availabilityResponse) => {
  if (Array.isArray(availabilityResponse)) {
    return availabilityResponse.length > 0;
  }

  if (!availabilityResponse || typeof availabilityResponse !== 'object') {
    return false;
  }

  return Object.values(availabilityResponse).some(Boolean);
};

export const normalizeAvailabilityDate = (date) => {
  if (!date) {
    return null;
  }

  if (date instanceof Date) {
    return date.toLocaleDateString('en-CA');
  }

  return String(date).split('T')[0].split(' ')[0];
};

export const toDisplayDateString = (date) => {
  const normalizedDate = normalizeAvailabilityDate(date);
  if (!normalizedDate) {
    return null;
  }

  return new Date(`${normalizedDate}T00:00:00`).toDateString();
};

export const uniqueAvailabilityDates = (dates) => {
  return Array.from(
    new Set(
      (dates || [])
        .map(normalizeAvailabilityDate)
        .filter(Boolean),
    ),
  );
};

export const mapWithConcurrency = async (items, limit, mapper) => {
  if (!items.length) {
    return [];
  }

  const results = new Array(items.length);
  let nextIndex = 0;

  const workers = Array.from(
    { length: Math.min(Math.max(limit, 1), items.length) },
    async () => {
      while (nextIndex < items.length) {
        const currentIndex = nextIndex;
        nextIndex += 1;
        results[currentIndex] = await mapper(items[currentIndex], currentIndex);
      }
    },
  );

  await Promise.all(workers);
  return results;
};
